export const DASHBOARD_API_ROUTES = {
   DASHBOARD: 'dashboard',
   TEST_DETAILS :'userTestDetails',
   USER_PERFORMANCE:"usertestperformance"
}